// swiperInit.js
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const multiColumCards = document.querySelectorAll('.media-gallery');

    multiColumCards.forEach(section => {
        const cardSlider = section.querySelectorAll('.mg-main-slider');

        if (cardSlider.length > 0) {
            cardSlider.forEach(slider => {
                new Swiper(slider, {
                    slidesPerView: 1.26,
                    spaceBetween: 32,
                    loop: false,
                    navigation: {
                        prevEl: section.querySelector('.mg-button-prev'),
                        nextEl: section.querySelector('.mg-button-next'),
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 24,
                        },
                        991: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                        },
                        1200: {
                            slidesPerView: 4,
                            spaceBetween: 28,
                        },
                    },
                });
            });
        }

        if (section.querySelector('.mg-modal-slider')) {
            initSwiper();
        }

        section.querySelectorAll('.mg-card').forEach(function(element) {
            element.addEventListener('click', function() {
                document.body.classList.add('scroll-fixed');
                const targetId = element.getAttribute('data-href');
                navigateToSlide(targetId);
                section.querySelector('.mg-modal').classList.add('is-active');
            });
        });

        document.addEventListener('click', function(event) {
            if (event.target.closest('.media-gallery .mg-modal-close-btn') || event.target.closest('.media-gallery .mg-modal-overlay')) {
                document.body.classList.remove('scroll-fixed');
                const wrap = section.querySelector('.mg-modal');
                if (wrap) {
                    wrap.classList.remove('is-active');
                }
            }
        });
    });


    /* Leadership Bio grid End */

    function navigateToSlide(targetId) {
        const sliders = document.querySelectorAll('.mg-modal-slider');
        sliders.forEach(function(slider) {
            const targetSlide = slider.querySelector('.mg-modal-inner[data-id="' + targetId + '"]');
            const slideIndex = Array.from(slider.querySelectorAll('.mg-modal-inner')).indexOf(targetSlide);
            if (slideIndex !== -1) {
                slider.swiper.slideTo(slideIndex);
            }
        });
    }

    function initSwiper() {
        const lead_slider_all = document.querySelectorAll('.mg-modal-slider');
        lead_slider_all.forEach(function(slider) {
            new Swiper(slider, {
                freeMode: false,
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                autoHeight: true,
                spaceBetween: 30,
                loop: false,
                navigation: {
                    prevEl: slider.parentNode.querySelector('.mg-modal-button-prev'),
                    nextEl: slider.parentNode.querySelector('.mg-modal-button-next'),
                },
            });
        });
    }

});